import Search from "./components/Search";

function App() {
    return (
        <div className="container">
            <Search />
        </div>
    );
}

export default App;
